import { useSelector } from 'react-redux'
import { RootState } from "../reducers";
import { getTranslate } from 'react-localize-redux'

export default function useTranslate() {
  const localizeState = useSelector((state: RootState) => state.localize)
  return getTranslate(localizeState)
}
